import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Container from './Container';

const style = props => {
  const { theme } = props;

  const states = {
    info: `
      color: ${theme.primary.primary300};
      background-color: ${theme.primary.primary100};
      border-color: ${theme.primary.primary200};
    `,
    success: `
      color: ${theme.secondary.normal};
      background-color: ${theme.secondary.secondary100};
      border-color: ${theme.secondary.normal};
    `,
    error: `
      color: ${theme.error.normal};
      background-color: ${theme.error.error100};
      border-color: ${theme.error.normal};
    `,
  };
  const state = Object.keys(states).find(key => props[key]) || 'info';

  return states[state];
};

const StyledContainer = styled(Container)`
  display: flex;
  align-items: center;
  width: ${props => props.width || '340px'};
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;
  ${style}
`;

const Notification = ({ children, ...props }) => (
  <StyledContainer {...props}>{children}</StyledContainer>
);

Notification.propTypes = {
  children: PropTypes.node,
};

Notification.defaultProps = {
  children: null,
};

export default Notification;
